'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { UpsellRootContext } from './context/upsell-root.context';
import { upsellMediaRecipe } from './styles/upsell-media.styles';
import type { UpsellMediaPropsInterface } from './types/upsell-media.types';

/**
 * @since 10.0.0
 */
export const UpsellMedia = forwardRef<HTMLDivElement, UpsellMediaPropsInterface>(
  (props: UpsellMediaPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { tone } = useContext(UpsellRootContext);
    const styles = css(upsellMediaRecipe.raw({ tone }), cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Upsell.Media"
        className={cx('c11n', 'c11n_upsell__media', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

UpsellMedia.displayName = 'Upsell.Media';
